import React from 'react';
import Link from 'next/link';

export default function Footer() {
  return (
    <footer className="bg-navy border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-8 h-8 rounded-xl bg-saffron flex items-center justify-center">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M9 2L3 6v6l6 4 6-4V6L9 2z" fill="#0F2044" />
                  <path d="M9 5.5L5.5 8v3L9 13l3.5-2V8L9 5.5z" fill="#F5A623" opacity="0.6" />
                </svg>
              </div>
              <span className="font-display text-xl font-bold text-slate tracking-tight">Minikwa</span>
            </div>
            <p className="text-slate/50 text-sm leading-relaxed max-w-xs">
              A smarter way to prepare for every exam. Built for Indian students, by people who understand the pressure.
            </p>
          </div>

          {/* Exams */}
          <div>
            <p className="text-slate/40 text-xs font-bold uppercase tracking-widest mb-4">Exams</p>
            <nav className="flex flex-col gap-2.5">
              {['SSC CGL', 'IBPS PO', 'SBI PO', 'UPSC CSE', 'JEE Main', 'NEET UG', 'RRB NTPC', 'State PSC']?.map((exam) => (
                <Link key={exam} href="/exams" className="text-slate/50 hover:text-slate text-sm transition-colors">
                  {exam}
                </Link>
              ))}
            </nav>
          </div>

          {/* Product */}
          <div>
            <p className="text-slate/40 text-xs font-bold uppercase tracking-widest mb-4">Product</p>
            <nav className="flex flex-col gap-2.5">
              {[
                { label: 'All Test Series', href: '/exams' },
                { label: 'Mock Tests', href: '/exams' },
                { label: 'Previous Year Papers', href: '/exams' },
                { label: 'Pricing', href: '/pricing' },
                { label: 'Student Dashboard', href: '/dashboard' },
              ]?.map((link) => (
                <Link key={link?.label} href={link?.href} className="text-slate/50 hover:text-slate text-sm transition-colors">
                  {link?.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Company */}
          <div>
            <p className="text-slate/40 text-xs font-bold uppercase tracking-widest mb-4">Company</p>
            <nav className="flex flex-col gap-2.5">
              {[
                { label: 'About Minikwa', href: '/about' },
                { label: 'Contact Us', href: '/about' },
                { label: 'Privacy Policy', href: '/about' },
                { label: 'Terms of Service', href: '/about' },
              ]?.map((link) => (
                <Link key={link?.label} href={link?.href} className="text-slate/50 hover:text-slate text-sm transition-colors">
                  {link?.label}
                </Link>
              ))}
            </nav>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate/30 text-sm">© 2026 Minikwa. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-slate/40 hover:text-slate/70 transition-colors" aria-label="Twitter / X">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.259 5.63 5.905-5.63Zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
              </svg>
            </a>
            <a href="#" className="text-slate/40 hover:text-slate/70 transition-colors" aria-label="Instagram">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <circle cx="12" cy="12" r="4" />
                <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" />
              </svg>
            </a>
            <a href="#" className="text-slate/40 hover:text-slate/70 transition-colors" aria-label="YouTube">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}